// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1__a80880ce6bc3f766c97e","cls2":"FeedbackModal-cls2__cd07d99b67e71ebe71a2 FeedbackModal-cls1__a80880ce6bc3f766c97e"};